/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import moment from 'moment';
import _ from 'lodash';
import * as actionTypes from './actionTypes';
import { initialState } from './reducer';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

// const logInUserID = localStorage.getItem('logInUser');

export const setGCLExtraState = (data) => ({
  type: actionTypes.GET_GCL_EXTRA_STATE,
  extraState: data,
});

// store plantype values
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA_GCL,
  payload: data,
});

// To get plantype data
export const getCheckBoxValue = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      let data = [];
      if (response.data) {
        data = response.data.PLAN_TYPE_CD || [];
      }
      return dispatch(dispatchPlanType(data));
    })
    .catch(() => {
      dispatch(dispatchPlanType([]));
    });
};

//  get rebate programe list data
export const getCommonDropdownList = (value) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      let newData = [];
      if (
        response.data &&
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        newData = response.data.data || [];
      }
      return newData;
    })
    .catch(() => {
      return [];
    });
};

export const dispatchTemplateType = (data) => ({
  type: actionTypes.GET_ALL_TEMPLATE_TYPE,
  TemplateType: data,
});

//  error msg dispatch function
export const dispatchErrorMsg = (data) => ({
  type: actionTypes.ERROR_MESSAGES_GCL,
  payload: data,
});

export const getAllTemplateType = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_TEMPLATE_TYPE, values)
    .then((response) => {
      return dispatch(dispatchTemplateType(response.data));
    })
    .catch(() => {
      dispatch(dispatchTemplateType([]));
    });
};

// dispatch quarter value function
export const dispatchQuarterValue = (data) => ({
  type: actionTypes.GET_QUARTER_VALUE_GCL,
  payload: data,
});
//  get quarter value data
export const getQuarterValue = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.REBATE_MAX_QTR_ENROLL, values)
    .then((response) => {
      let newData = '';
      if (
        response.data &&
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        newData = response.data?.data?.maxFrozenQtrDisplay || '';
      }
      return dispatch(dispatchQuarterValue(newData));
    })
    .catch(() => {
      dispatch(dispatchQuarterValue(''));
    });
};

// store status bit for navigation
export const statusBit = (data) => ({
  type: actionTypes.FLAG_NAVIGATION,
  payload: data,
});

// getGCLData search list
export const dispatchGCLData = (data) => ({
  type: actionTypes.GET_GCL_DATA,
  payload: data,
});

export const getGCLData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_GCL_TABLE_DATA, value)
    .then((response) => {
      // dispatch(statusBit(1));
      let tempObj = [];
      if (
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        let newData =
          response.data?.gclVO?.generateCollectionLetterListVO || [];
        if (
          !_.isEmpty(newData) &&
          value.daysSinceInvoiceDistributed &&
          value.daysSinceInvoiceDistributed !== ''
        ) {
          newData = _.filter(
            newData,
            (l) =>
              parseInt(l.dayCount, [0, 10000]) >
              parseInt(value.daysSinceInvoiceDistributed, [0, 10000])
          );
        }
        if (!_.isEmpty(newData)) {
          if (value.paymentStatus === 1) {
            newData = _.filter(
              newData,
              (l) => parseFloat(l.amountPaidDate) === 0
            );
          }
          if (value.paymentStatus === 2) {
            newData = _.filter(
              newData,
              (l) =>
                parseFloat(l.amountPaidDate) === 0 &&
                parseFloat(l.amountOwed) > 0
            );
          }
          if (value.paymentStatus === 3) {
            newData = _.filter(newData, (l) => {
              const perPaid =
                l.percentPaid || l.percentPaid !== '0'
                  ? parseFloat(l.percentPaid).toFixed(6)
                  : 0.0;
              if (_.lt(perPaid, parseFloat(value.percentPaid))) {
                return l;
              }
            });
          }
          if (value.paymentStatus === 4) {
            newData = _.filter(
              newData,
              (l) =>
                (l.amountOwed || l.amountOwed !== '0'
                  ? parseFloat(l.amountOwed)
                  : 0.0) > parseFloat(value.amountOwed)
            );
          }
          if (value.paymentStatus === 5) {
            newData = _.filter(
              newData,
              (l) =>
                parseFloat(l.amountPaidDate) < parseFloat(l.currRebateAmount)
            );
          }
          tempObj = newData.map((item) => {
            item.invDistDate = item.invDistDate
              ? moment(item.invDistDate).format('MM/DD/YYYY')
              : '';
            item.percentPaid = item.percentPaid
              ? parseFloat(item.percentPaid).toFixed(6)
              : parseFloat(0).toFixed(6);
            item.amountOwed = item.amountOwed
              ? parseFloat(item.amountOwed).toFixed(2)
              : parseFloat(0).toFixed(2);
            item.currRebateAmount = item.currRebateAmount
              ? parseFloat(item.currRebateAmount).toFixed(2)
              : parseFloat(0).toFixed(2);
            item.invAmount = item.invAmount
              ? parseFloat(item.invAmount).toFixed(2)
              : parseFloat(0).toFixed(2);
            item.amountPaidDate = item.amountPaidDate
              ? parseFloat(item.amountPaidDate).toFixed(2)
              : parseFloat(0).toFixed(2);
            item.emailAdd = item.emailAdd ? item.emailAdd : '';
            item.emailClrId =
              !item.emailAdd || item.emailAdd === '' ? '11534335' : '';
            if (item.sentDt) {
              item.sendClrId = '11513855';
            } else {
              item.sendClrId = null;
            }
            return item;
          });
        }
        return dispatch(
          dispatchGCLData({
            ...response.data,
            gclVO: {
              ...response.data?.gclVO,
              generateCollectionLetterListVO: tempObj,
            },
          })
        );
      }
      return dispatch(
        dispatchGCLData({
          ...response.data,
        })
      );
    })
    .catch(() => {
      dispatch(
        dispatchGCLData({
          status: '000',
          message: 'FAIL',
        })
      );
    });
};

// update detail list
export const dispatchGCLDetailList = (data) => ({
  type: actionTypes.GET_GCL_DETAIL_PAGE_DATA_LIST,
  gclDetailPageList: data,
});

// get all search data ans list in detail page
export const dispatchGCLDetailPageData = (data) => ({
  type: actionTypes.GET_GCL_DETAIL_PAGE_DATA,
  payload: data,
});
export const dispatcPriorQtrData = (data) => ({
  type: actionTypes.GET_PRIOR_QTR_DATA,
  payload: data,
});

export const selectionList = (data) => {
  return {
    type: actionTypes.SELECTION_TYPE_OPTIONS,
    payload: data,
  };
};
export const dispatchSaveGCLData = (data) => ({
  type: actionTypes.SAVE_GCL_DATA,
  payload: data,
});

export const saveGCLData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SAVE_GCL_DATA, value)
    .then((response) => {
      return dispatch(dispatchSaveGCLData(response.data));
    })
    .catch(() => {
      dispatch(dispatchSaveGCLData({ message: 'FAIL', status: '002' }));
    });
};

// get from mail id
export const dispatchGetFromMailID = (data) => ({
  type: actionTypes.GET_FROM_MAIL_ID_COLLECTION_LETTER,
  payload: data,
});

export const getFromMailIDCreateTemplate = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_FROM_MAIL_ID, value)
    .then((response) => {
      let newData = '';
      if (
        response.data &&
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        newData = response.data.data || response.data.fromMailId;
      }
      const data = { isUpdate: false, fromMailId: newData };
      return dispatch(dispatchGetFromMailID(data));
    })
    .catch((response) => {
      dispatch(dispatchGetFromMailID({ isUpdate: false, fromMailId: '' }));
    });
};

// update from mail id value
export const updateFromMailIDCreateTemplate = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_FROM_MAIL_ID, value)
    .then((response) => {
      let newData = '';
      if (
        response.data &&
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        // newData = response.data.data || response.data.updatedMailId;
        newData = value.mailId;
      }
      const data = { isUpdate: true, fromMailId: newData };
      return dispatch(dispatchGetFromMailID(data));
    })
    .catch(() => {
      dispatch(dispatchGetFromMailID({ isUpdate: true, fromMailId: '' }));
    });
};

// get to mail id
export const dispatchGetToMailID = (data) => ({
  type: actionTypes.GET_TO_MAIL_ID_GCL,
  toMailId: data,
});

// update to mail id value
export const callUpdateToMailAPI = (value) => {
  return axios
    .post(serviceEndPoint.UPDATE_TO_EMAIL_FOR_GCL, value)
    .then((response) => {
      let newData = '';
      if (
        response.data &&
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        newData = value.mailId;
      }
      return newData;
    })
    .catch(() => {
      return '';
    });
};

// update to mail id value
export const updateToMailIDCreateTemplate =
  (value, logInUser) => async (dispatch) => {
    if (!_.isEmpty(value)) {
      const newList = await _.map(value, async (val, ind) => {
        const request = {
          invoiceNum: val.invNum,
          mailId: val.emailAdd,
          userId: logInUser,
        };
        const mailRes = await callUpdateToMailAPI(request);
        val.emailAdd = mailRes;
        val.emailAdd1 = mailRes;
        if (mailRes && mailRes !== '') {
          val.mailUpdate = true;
        } else {
          val.mailUpdate = false;
        }
        return val;
      });

      const allMail = await Promise.all(newList).then((d) => {
        return d;
      });
      return dispatch(
        dispatchGetToMailID({ updateAction: true, data: allMail })
      );
    }
    return dispatch(dispatchGetToMailID({ updateAction: true, data: [] }));
  };

// for send mail
export const dispatchSendGCLData = (data) => ({
  type: actionTypes.SEND_GCL_DATA,
  payload: data,
});

export const sendGCLDataAPI = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SEND_GCL_DATA, value)
    .then((response) => {
      return dispatch(dispatchSendGCLData(response.data));
    })
    .catch(() => {
      dispatch(dispatchSendGCLData([]));
    });
};

// get print pdf
export const dispatchPrintPreview = (data) => ({
  type: actionTypes.GET_GCL_PDF_DATA,
  pdfPreview: data,
});

export const getPrintPreview = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_GCL_PDF_DATA, value, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      const newData = {
        status: '001',
        message: 'SUCESS',
        data: response.data,
      };
      return dispatch(dispatchPrintPreview(newData));
    })
    .catch((response) => {
      dispatch(
        dispatchPrintPreview({
          status: '000',
          message: 'FAIL',
          data: '',
        })
      );
    });
};

export const getShowPrintPreview = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_SHOW_GCL_PDF_DATA, value, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      const newData = {
        status: '001',
        message: 'SUCESS',
        data: response.data,
      };
      return dispatch(dispatchPrintPreview(newData));
    })
    .catch((response) => {
      dispatch(
        dispatchPrintPreview({
          status: '000',
          message: 'FAIL',
          data: '',
        })
      );
    });
};

export const clearGenerateCollectionLetterPageDispatch = (val) => {
  return {
    type: actionTypes.GENERATE_COLLECTION_LETTER_CLEAR_REDUX_DATA,
    payload: val,
  };
};

export const clearGenerateCollectionLetterPage = () => (dispatch, getState) => {
  const reduxObj = getState()?.sharedState?.GeneratecdReducer;
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  let newObj1 = {};
  if (!_.isEmpty(updateTabs)) {
    const newObj = _.cloneDeep(reduxObj);
    if (
      updateTabs.filter(
        (x) =>
          x.navTo === '/GenerateCollectionLetter' ||
          x.navTo === '/Collectionletterdetail'
      ).length !== 0
    ) {
      newObj1 = newObj;
      if (
        updateTabs.filter((x) => x.navTo === '/Collectionletterdetail')
          .length === 0
      ) {
        newObj1 = {
          ...newObj1,
          gclDetailPageData: [],
          gclDetailPageList: [],
          saveGclData: [],
          sendGclData: [],
          toMailId: [],
          fromMailId: [],
          pdfPreview: '',
        };
      }
    } else {
      newObj1 = { ...initialState };
    }
  } else {
    newObj1 = { ...initialState };
  }

  dispatch(clearGenerateCollectionLetterPageDispatch(newObj1));
};
